import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import checkedSpecificResourceFragment from '~/modules/resource-management/graphql/checkedSpecificResource.fragment';
import { useResourcePermissions } from './useResourcePermissions';

export const RESOURCE_DETAILS_QUERY = gql`
  query getResourceDetailsBySlug(
    $userSlug: String!
    $hasViewProjectRolePermission: Boolean!
    $hasViewCostCenterPermission: Boolean!
    $hasViewServiceCenterPermission: Boolean!
    $hasViewLocationPermission: Boolean!
    $hasViewDepartmentPermission: Boolean!
    $hasViewEmployeeTypePermission: Boolean!
    $hasViewDivisionPermission: Boolean!
    $hasViewCustomFieldsPermission: Boolean!
    $hasViewSkillAssignmentPermission: Boolean!
  ) {
    resource(userSlug: $userSlug) {
      ...CheckedSpecificResourceFragment
      certificates(includeExpired: true) {
        id
        uri
        name
        issueDate
        expiryDate
        issuer
        expires
        credentialId
        credentialUrl
      }
      tags {
        id
        tag {
          id
          name
        }
        value {
          id
          value
        }
      }
      userDefinedSkills @include(if: $hasViewSkillAssignmentPermission) {
        id
        uri
        displayText
        skillLevel {
          id
          uri
          displayText
          rating
        }
      }
    }
  }
  ${checkedSpecificResourceFragment}
`;

const useResourceDetails = ({
  userSlug,
  isPsaPraaUserProfileNudgesEnabled
}) => {
  const {
    hasViewProjectRolePermission,
    hasViewCostCenterPermission,
    hasViewServiceCenterPermission,
    hasViewLocationPermission,
    hasViewDepartmentPermission,
    hasViewEmployeeTypePermission,
    hasViewDivisionPermission,
    hasViewCustomFieldsPermission,
    hasViewSkillAssignmentPermission
  } = useResourcePermissions(userSlug);

  const { loading, error, data: { resource } = {} } = useQuery(
    RESOURCE_DETAILS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        userSlug,
        hasViewProjectRolePermission,
        hasViewCostCenterPermission,
        hasViewServiceCenterPermission,
        hasViewLocationPermission,
        hasViewDepartmentPermission,
        hasViewEmployeeTypePermission,
        hasViewDivisionPermission,
        hasViewCustomFieldsPermission,
        hasViewSkillAssignmentPermission:
          hasViewSkillAssignmentPermission && isPsaPraaUserProfileNudgesEnabled
      }
    }
  );

  return {
    loading,
    resourceDetails: resource,
    error
  };
};

export default useResourceDetails;
